import { registerChunkedMergeStrategy } from "../../reactQueryFetcherAdapters/utils/chunkedPusherMerge";
import { mergeCampaignQaPreviewChunks, mergeCampaignQaPusherChunks } from "./mergeCampaignQaPusherChunks";
import type { CampaignQaPusherChunk } from "./types";

let registered = false;

/**
 * Registers the "campaignQa" and "campaignQaPreview" chunked merge strategies
 * with the generic POSTWS chunked-delivery layer.
 *
 * Call at the top of any hook body that passes `chunkedMerge: "campaignQa"` or
 * `"campaignQaPreview"` — the idempotent guard makes repeated calls free.
 */
export function registerCampaignQaChunkedMerge(): void {
  if (registered) {
    return;
  }
  registered = true;

  registerChunkedMergeStrategy<CampaignQaPusherChunk, unknown>("campaignQa", {
    completionKey: "chunked_result_complete",
    merge(envelope, chunks) {
      return {
        ...envelope,
        agent_results: mergeCampaignQaPusherChunks(chunks),
      };
    },
  });

  registerChunkedMergeStrategy<CampaignQaPusherChunk, unknown>("campaignQaPreview", {
    completionKey: "chunked_result_complete",
    merge(envelope, chunks) {
      return {
        ...envelope,
        result: null,
        errors: null,
        qa_results: mergeCampaignQaPreviewChunks(chunks),
      };
    },
  });
}
